export default "__VITE_ASSET__CQj5lbZ$__"